/*
 * Early Black Friday free gift (Nov 2026)
 * Keeps exactly one Jerusalem Cross holy water 3-pack gift line in the cart while
 * the non-gift subtotal is $150+, and removes it below that. The $0.00 price comes
 * from the automatic discount "Early Black Friday - Free Jordan River Holy Water Gift".
 * Also powers the "Add" buttons of the cart drawer upsell block.
 */
(function () {
  if (window.__ebfGift) return;
  var CFG = window.ebfGiftConfig || {};
  var VARIANT_ID = Number(CFG.variantId || 67695269216323);
  var THRESHOLD = Number(CFG.threshold || 15000); // cents
  var ENABLED = CFG.enabled !== false;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var nativeFetch = window.fetch.bind(window);
  var busy = false, pending = false, timer = null;

  window.__ebfGift = true;

  function isGift(item) {
    return item.properties && item.properties._ebf_gift;
  }

  function json(url, body) {
    var opts = body
      ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }
      : { headers: { Accept: 'application/json' } };
    return nativeFetch(url, opts).then(function (r) { return r.json(); });
  }

  function refreshUI() {
    if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return Promise.resolve(); }
    return nativeFetch(root + 'cart?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var doc = new DOMParser().parseFromString(sections['cart-drawer'] || '', 'text/html');
        ['cart-drawer-items', '.cart-drawer__footer', '.drawer__heading'].forEach(function (sel) {
          var target = document.querySelector(sel), source = doc.querySelector(sel);
          if (target && source) target.replaceWith(source);
        });
        var drawer = document.querySelector('cart-drawer');
        var fresh = doc.querySelector('cart-drawer');
        if (drawer && fresh) drawer.classList.toggle('is-empty', fresh.classList.contains('is-empty'));
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && sections['cart-icon-bubble']) {
          var b = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
          if (b) bubble.innerHTML = b.innerHTML;
        }
      })
      .catch(function () {});
  }

  function sync() {
    if (!ENABLED) return Promise.resolve(false);
    if (busy) { pending = true; return Promise.resolve(false); }
    busy = true;
    return json(root + 'cart.js')
      .then(function (cart) {
        var subtotal = 0, giftLines = [];
        cart.items.forEach(function (item) {
          if (isGift(item)) giftLines.push(item);
          else subtotal += item.final_line_price;
        });
        var eligible = subtotal >= THRESHOLD;
        var updates = {};
        var changed = false;

        if (eligible) {
          giftLines.forEach(function (line, i) {
            var want = i === 0 ? 1 : 0;
            if (line.quantity !== want) { updates[line.key] = want; changed = true; }
          });
        } else {
          giftLines.forEach(function (line) { updates[line.key] = 0; changed = true; });
        }

        var p = Promise.resolve();
        if (changed) p = p.then(function () { return json(root + 'cart/update.js', { updates: updates }); });
        if (eligible && giftLines.length === 0) {
          changed = true;
          p = p.then(function () {
            return json(root + 'cart/add.js', {
              items: [{ id: VARIANT_ID, quantity: 1, properties: { _ebf_gift: '1', 'Free Gift': 'Early Black Friday' } }]
            });
          });
        }
        return p.then(function () { return changed; });
      })
      .catch(function () { return false; })
      .then(function (changed) {
        busy = false;
        if (pending) { pending = false; return sync().then(function (c2) { return changed || c2; }); }
        return changed;
      });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      sync().then(function (changed) { if (changed) refreshUI(); });
    }, 250);
  }

  // Watch every cart mutation made by the theme or apps (add / change / update / clear).
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var res = nativeFetch(input, init);
    if (CART_RE.test(url)) res.then(function () { schedule(); }).catch(function () {});
    return res;
  };
  var xhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (CART_RE.test(String(url))) this.addEventListener('load', function () { schedule(); });
    return xhrOpen.apply(this, arguments);
  };

  // Upsell "Add" buttons (rendered inside the cart drawer, which is re-rendered often).
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-ebf-add]');
    if (!btn) return;
    e.preventDefault();
    btn.setAttribute('aria-busy', 'true');
    json(root + 'cart/add.js', { items: [{ id: Number(btn.getAttribute('data-ebf-add')), quantity: 1 }] })
      .then(function () { return sync(); })
      .then(function () { return refreshUI(); })
      .catch(function () { btn.removeAttribute('aria-busy'); });
  });

  // Initial check (cart may have changed in another tab, or before this script loaded).
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();
})();
